import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

export default class Startup {

	run( $element ) {

		// Retrieve the widget config from data- attribute of parent
		const dataSettings = $element.attr( 'data-settings' );
		const pageSettings = jQuery('[data-elementor-type="wp-page"]').attr( 'data-elementor-settings' );
		const checkFilterSettings = $element.attr( 'data-checked-filters-settings' );

		// Parse the config and set in app properties
		const config = JSON.parse( dataSettings || '{}' );
		const pageConfig = JSON.parse( pageSettings || '{}' );
		const checkFilterConfig = (checkFilterSettings !== undefined) ? JSON.parse( checkFilterSettings || '{}' ) : [];

		// pass data-id attribute into the app
		// Render the app
		createRoot( $element[0] ).render(<App config={config} pageConfig={pageConfig} checkedFilterConfig={checkFilterConfig} />);

		return this;
	}
}
